module.exports = __webpack_public_path__ + "static/media/BoostBanner.7bf7e485.png";